// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TagLockSvg from '@rsuite/icon-font/lib/application/TagLock';
var TagLock = createSvgIcon({
  as: TagLockSvg,
  ariaLabel: 'tag lock',
  category: 'application',
  displayName: 'TagLock'
});
export default TagLock;